import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import { MY_LEARNING_TABS, getMyLearningUrl, useMyLearningParams } from '..';
import I18n from 'I18n';
import useNavigate from '../../../hooks/useNavigate';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
export const MyLearningTabNavigation = () => {
  const navigate = useNavigate();
  const {
    tab: selectedTab
  } = useMyLearningParams();
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(UITabs, {
    className: isMobile ? 'm-bottom-6' : 'm-bottom-5',
    selected: selectedTab,
    children: MY_LEARNING_TABS.map(tab => /*#__PURE__*/_jsx(UITab, {
      onClick: () => navigate(getMyLearningUrl(tab)),
      tabId: tab,
      title: I18n.text(`learningCenter.myLearning.tabs.${tab}`)
    }, `my-learning-nav_${tab}`))
  });
};